import {Component, ViewChild, inject } from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslatePipe} from "../../shared/pipes/translate.pipe";
import {LanguageService} from "../../shared/services/language.service";
import {HeadlineComponent} from "../../shared/elements/headline/headline.component";
import {IconBadgeComponent} from "../../shared/elements/icon-badge/icon-badge.component";
import {FormInputComponent} from "../../shared/elements/form-input/form-input.component";
import {FormBuilder, FormGroup} from '@angular/forms';
import {FormButtonComponent} from "../../shared/elements/form-button/form-button.component";
import {DialogComponent} from '@syncfusion/ej2-angular-popups';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {FormDropdownComponent} from "../../shared/elements/form-dropdown/form-dropdown.component";
import {ToastModule} from '@syncfusion/ej2-angular-notifications';
import {LinkComponent} from "../../shared/elements/link/link.component";
import {LayoutService} from "../../shared/services/layout.service";
import {TooltipModule} from "@syncfusion/ej2-angular-popups";
import {TooltipComponent} from "../../shared/elements/tooltip/tooltip.component";
import {DialogService} from "../../shared/services/dialog.service";
import {StepHeaderComponent} from "../../shared/elements/step-header/step-header.component";
import {StepContentComponent} from "../../shared/elements/step-content/step-content.component";
import {FormLabelComponent} from "../../shared/elements/form-label/form-label.component";
import {FormTextareaComponent} from "../../shared/elements/form-textarea/form-textarea.component";
import {FormCheckboxComponent} from "../../shared/elements/form-checkbox/form-checkbox.component";
import {FormRadioComponent} from "../../shared/elements/form-radio/form-radio.component";
import {ContentComponent} from "../../shared/elements/content/content.component";
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import {RouterService} from "../../shared/services/router.service";
import {LoadingService} from "../../shared/services/loading.service";
import { BreadcrumbModule } from '@syncfusion/ej2-angular-navigations';
import {NgSrcImageErrorDirective} from '../../shared/directives/ng-src-image-error.directive';

@Component({
    selector: 'app-community-topicsd',
    imports: [
        CommonModule,
        DialogModule,
        TranslatePipe,
        HeadlineComponent,
        FormInputComponent,
        FormButtonComponent,
        FormDropdownComponent,
        ToastModule,
        IconBadgeComponent,
        LinkComponent,
        TooltipModule,
        TooltipComponent,
        StepHeaderComponent,
        StepContentComponent,
        FormLabelComponent,
        FormTextareaComponent,
        FormCheckboxComponent,
        FormRadioComponent,
        ContentComponent,
        TimePickerModule,
        BreadcrumbModule,
        NgSrcImageErrorDirective
    ],
    templateUrl: './community-topicsd.component.html',
    styleUrl: './community-topicsd.component.scss'
})
export class CommunityTopicsdComponent {
  layoutService = inject(LayoutService);
  private formBuilder = inject(FormBuilder);
  private languageService = inject(LanguageService);
  dialogService = inject(DialogService);
  routerService = inject(RouterService);
  loadingService = inject(LoadingService);

@ViewChild('createNewTopicDialog') createNewTopicDialog: DialogComponent | any;
imageSrc= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";
imageSrc1= "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSb72uP8MZ7wzWKhwGjQhb11TXHkMG5zo2ouw&";
onOpenDialog = (event: any, id: string): void => {
  event.preventDefault();
  if(id == 'show-newtopicdialog')
  {
    this.createNewTopicDialog.show();
  }

};

onClose(id: string): void{
  if(id == 'show-newtopicdialog')
  {
    this.createNewTopicDialog.hide();
  }
}
/**** FORM GROUP */
public communityTopicForm: FormGroup = this.formBuilder.group({
  searchString: [''],
  search_filter: [''],
  topic_filter: [''],
  community_topic_title: [''],
  community_topic_description: [''],
  community_topic_visibility: [0],
  join_by_invite_only: [''],
  community_likes_visibility: [0],
  community_views_visibility: [0],
  community_fallowers_visibility: [0]
});

searchFilterOptions: any[] = [
  {id: 'discussion', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINCURRENTDISCUSSIONS')},
  {id: 'topic_names', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINCURRENTTOPICNAMES')},
  {id: 'community_names', name: this.languageService.getTranslationByKey('COMMUNITYSEARCHINCURRENTCOMMUNITYNAMES')}
];

topicFilterOptions: any[] = [
  {id: 'all', name: this.languageService.getTranslationByKey('COMMUNITYALLTOPICSFILTER')},
  {id: 'sunscribed_topics', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYSUBSCRIBEDTOPICSFILTER')},
  {id: 'unsubscribed_topics', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYUNSUBSCRIBEDTOPICSFILTER')},
  {id: 'public', name: this.languageService.getTranslationByKey('COMMUNITYSHOWONLYPUBLICTOPICSFILTER')},
  {id: 'invite_only', name: this.languageService.getTranslationByKey('COMMUNITYSHOWTOPICSINVITEONLYFILTER')},
  {id: 'by_popularity', name: this.languageService.getTranslationByKey('COMMUNITYSHOWTOPICSBYPOPULARITYFILTER')}
];

public activeStep = 0;
  public participantsGroupIDs: number[] = [8,6];
  public participantsMails: string[] = [];
  public pushUserIDs: number[] = [];
  pushGroupIDs: number[] = [];
  public steps: string[] = [this.languageService.getTranslationByKey('COMMUNITYTOPICTEXTCONTENTMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSPLASHMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICEDITORPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSUBSCRIBERSPERMISSIONSMENUTEXT'), this.languageService.getTranslationByKey('COMMUNITYTOPICSETTINGSMENUTEXT')];
}
